// Susmie's Analytics

(function () {
  var ENDPOINT = window.SUSMIES_ENDPOINT || 'https://susmies.net/api/events/enqueue.php';

  function uuidv4() {
    try { if (crypto && crypto.randomUUID) return crypto.randomUUID(); } catch(e){}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){
      var r=Math.random()*16|0, v=c==='x'?r:(r&0x3|0x8); return v.toString(16);
    });
  }

  function postPlain(obj) {
    var body = JSON.stringify(obj);
    try {
      // if (navigator.sendBeacon) {
      //   var ok = navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }));
      //   if (ok) return;
      // }
    } catch(e){}
    try {
      // fetch(ENDPOINT, {
      //   method: 'POST',
      //   body: new Blob([body], { type: 'text/plain' }),
      //   keepalive: true,
      //   mode: 'cors',
      //   credentials: 'omit'
      // }).catch(function(){});
    } catch(e){}
  }

  function prune(o){
    if (!o || typeof o !== 'object') return;
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o,k)) {
      var v = o[k];
      if (v && typeof v === 'object') prune(v);
      if (v === undefined || v === null ||
          (typeof v === 'object' && !Array.isArray(v) && !Object.keys(v).length) ||
          (Array.isArray(v) && v.length === 0)) {
        delete o[k];
      }
    }
  }

  /**
   * window.SA(eventName, data)
   *  - eventName: string (obligatorio)
   *  - data: { event_id?, src?, ts?, currency?, transaction_id?, value?, items?, page?, user?, consent? }
   *    items: [{ item_id, item_name?, quantity?, price?, recommended_cart?, ... }]
   * Devuelve el event_id usado (útil para correlación).
   */
  function SA(eventName, data) {
    if (!eventName) return null;

    var currencyFromShopify = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var extra = {};
    if (data && typeof data === 'object') {
      if (data.extra && typeof data.extra === 'object') {
        for (var k in data.extra) if (Object.prototype.hasOwnProperty.call(data.extra, k)) extra[k] = data.extra[k];
      }
      if (data.meta && typeof data.meta === 'object') {
        for (var m in data.meta) if (Object.prototype.hasOwnProperty.call(data.meta, m)) extra[m] = data.meta[m];
      }
      var reserved = {
        event_id:1, src:1, ts:1, currency:1, transaction_id:1, value:1,
        items:1, page:1, user:1, consent:1, extra:1, meta:1
      };
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key) && !reserved[key]) {
          extra[key] = data[key];
        }
      }
    }

    var payload = {
      event_id: (data && data.event_id) || uuidv4(),
      event_name: eventName,
      src: (data && data.src) || 'custom_js',
      ts: (data && +data.ts) || Math.floor(Date.now()/1000),
      transaction_id: data && data.transaction_id,
      currency: (data && data.currency) || currencyFromShopify,
      value: (data && data.value != null) ? Number(data.value) : undefined,
      items: (data && data.items) || [],
      page: (data && data.page) || { url: location.href, referrer: document.referrer },
      user: data && data.user,
      consent: (data && typeof data.consent !== 'undefined') ? !!data.consent : true
    };

    if (Object.keys(extra).length) payload.extra = extra;

    prune(payload);
    postPlain(payload);
    return payload.event_id;
  }


  window.SA = SA;               // nombre corto
  window.SusmiesTrack = SA;     // alias
})();
(() => {
  const BASE_EUR = 75;

  const rate = Number(Shopify?.currency?.rate || 1);
  const currency = Shopify?.currency?.active || "EUR";

  const value = BASE_EUR * rate;

  const formatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency
  });

  const formatted = formatter.format(value);

  document
    .querySelectorAll(".metafield-rich_text_field")
    .forEach(el => {
      el.innerHTML = el.innerHTML.replaceAll(
        "--totebag-treshold--",
        formatted
      );
    });
})();
(function () {
  function getLSVariant() {
    try {
      var raw = localStorage.getItem('zc_newsletterpopup_ws_ab_variant');
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || (obj.v !== 'A' && obj.v !== 'B')) return null;
      if (typeof obj.exp === 'number' && obj.exp < Date.now()) return null; // expirada
      return obj.v;
    } catch (e) { return null; }
  }
  function readCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )'+name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1')+'=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getCookieVariant(){
    var v = (readCookie('zc_newsletterpopup_ws_ab_variant') || '').toUpperCase();
    return (v === 'A' || v === 'B') ? v : null;
  }
  function resolveVariant(){
    return getLSVariant() || getCookieVariant() || 'B';
  }

  if (typeof window.triggerVariantPopup !== 'function') {
    window.triggerVariantPopup = function triggerVariantPopup(variant){
      window._klOnsite = window._klOnsite || [];
      var map = (window.ZC_AB && ZC_AB.klaviyo) || {};
      var formId = map[variant] || map.A || 'TjGY2q';
      window._klOnsite.push(['openForm', formId]);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#newsletter-popup"]');
      if (!link) return;
      e.preventDefault();
      var variant = resolveVariant();
      window.triggerVariantPopup(variant);
    }, true);
  });
})();


document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a[href="#newsletter-popup-bak"]');
      if (link) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SnmmpG']);
      }
      
    });
});

;(function(){
  const _origFetch = window.fetch.bind(window);

  async function refreshPreorderDates() {
    try {
      const res  = await fetch(`${window.Shopify.routes.root}cart?section_id=preorder_cart_dates`);
      const html = await res.text();
      const parser = new DOMParser();
      const doc    = parser.parseFromString(html, 'text/html');
      const newBlock = doc.querySelector('div[data-preorder-dates]');
      if (!newBlock) return;
      document.querySelectorAll('div[data-preorder-dates]')
        .forEach(old => { old.innerHTML = newBlock.innerHTML; });
    } catch (err) {
      //console.error('PreorderDates Error:', err);
    }
  }

  window.fetch = function(input, init) {
    const url    = typeof input === 'string' ? input : input.url;
    const method = (init && init.method)
      ? init.method.toUpperCase()
      : (typeof input === 'object' && input.method)
        ? input.method.toUpperCase()
        : 'GET';

    if (method === 'POST' && /\/cart\/(add|change|update)/.test(url)) {
      const p = _origFetch(input, init);
      p
        .then(response => {
          response.clone().text().finally(refreshPreorderDates);
        })
        .catch(() => {
          refreshPreorderDates();
        });
      return p;
    }

    return _origFetch(input, init);
  };

  document.addEventListener('DOMContentLoaded', refreshPreorderDates);
})();

(function () {
  const endDate = new Date("2025-12-02T14:00:00Z"); // 15:00 hora España = 14:00 UTC - 01/12/25 23:59
  const maxRetries = 10;
  let retryCount = 0;
  let intervalId;

  const path = window.location.pathname;
  let messagePrefix = "ÚLTIMAS HORAS:";

  if (path === "/en" || path.startsWith("/en/")) {
    messagePrefix = "LAST HOURS:";
  } else if (path === "/fr" || path.startsWith("/fr/")) {
    messagePrefix = "DERNIÈRES HEURES:";
  } else if (path === "/it" || path.startsWith("/it/")) {
    messagePrefix = "ULTIME ORE:";
  }

  const emoji = "⌛";

  function updateCountdown() {
    const now = new Date();
    const diff = endDate - now;

    let displayText;

    if (diff <= 0) {
      displayText = `${emoji} ${messagePrefix} 00:00:00 ${emoji}`;
      clearInterval(intervalId);
    } else {
      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
      const seconds = (totalSeconds % 60).toString().padStart(2, '0');
      displayText = `${emoji} ${messagePrefix} ${hours}:${minutes}:${seconds} ${emoji}`;
    }

    const html = `<p>${displayText.toUpperCase()}</p>`;

    const links = document.querySelectorAll('a[href="#bf25-countdown"]');
    if (links.length === 0) {
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(updateCountdown, 500);
      } else {
        clearInterval(intervalId);
      }
      return;
    }

    links.forEach(link => {
      const currentText = link.textContent.trim().toUpperCase();
      const isEmpty = !currentText || currentText === "" || currentText === "⌛ ⌛";
      const isRepeating = currentText.includes("ÚLTIMAS HORAS") || currentText.includes("LAST HOURS") || currentText.includes("DERNIÈRES HEURES") || currentText.includes("ULTIME ORE");

      if (isEmpty || isRepeating) {
        link.innerHTML = html;
      }
    });
  }

  updateCountdown();
  intervalId = setInterval(updateCountdown, 1000);
})();

// =================== POPUP ===================
function triggerVariantPopup(variant){
  window._klOnsite = window._klOnsite || [];
  const formId = ZC_AB.klaviyo[variant] || ZC_AB.klaviyo.A;
  window._klOnsite.push(['openForm', formId]);
}

(function () {
  var DISCOUNT = '10%';
  var DEBUG = false;
  var NEWSLETTER_HREF_SELECTOR = 'a[href*="newsletter-popup"]';
  var activated = false; 
  var observer = null;
  function log(){ if (DEBUG) console.log.apply(console, ['%c[ANNOUNCE-AB]', 'color:#7b5cff;font-weight:bold;', ...arguments]); }
  function warn(){ if (DEBUG) console.warn.apply(console, ['[ANNOUNCE-AB][WARN]', ...arguments]); }

  function getLSVariant() {
    try {
      var raw = localStorage.getItem('zc_newsletterpopup_ws_ab_variant');
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || (obj.v!=='A' && obj.v!=='B')) return null;
      if (typeof obj.exp === 'number' && obj.exp < Date.now()) return null; // expirada
      return obj.v;
    } catch(e){ return null; }
  }
  function readCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )'+name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1')+'=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getCookieVariant(){
    var v = (readCookie('zc_newsletterpopup_ws_ab_variant') || '').toUpperCase();
    return (v==='A' || v==='B') ? v : null;
  }
  function resolveVariant(){
    var v = getLSVariant();
    if (v) { log('Variante desde localStorage:', v); return v; }
    v = getCookieVariant();
    if (v) { log('Variante desde cookie:', v); return v; }
    return null; 
  }
  function getLang(){
    var l = (document.documentElement.getAttribute('lang') || (window.Shopify&&Shopify.locale) || navigator.language || 'en')+'';
    return l.toLowerCase().split('-')[0];
  }
  function copyFor(lang, variant){
    var A = (variant==='A');
    switch(lang){
      case 'es': return A ? 'ÚNETE A NUESTRA NEWSLETTER PARA OBTENER UN ' + DISCOUNT + ' DE DESCUENTO'
                          : 'ÚNETE A NUESTRA NEWSLETTER';
      case 'en': return A ? 'JOIN OUR NEWSLETTER AND GET ' + DISCOUNT + ' OFF'
                          : 'JOIN OUR NEWSLETTER';
      case 'fr': return A ? 'INSCRIVEZ-VOUS À NOTRE NEWSLETTER POUR OBTENIR ' + DISCOUNT + ' DE RÉDUCTION'
                          : 'INSCRIVEZ-VOUS À NOTRE NEWSLETTER';
      case 'de': return A ? 'ABONNIERE UNSEREN NEWSLETTER UND ERHALTE ' + DISCOUNT + ' RABATT'
                          : 'ABONNIERE UNSEREN NEWSLETTER';
      case 'it': return A ? 'ISCRIVITI ALLA NEWSLETTER PER AVERE IL ' + DISCOUNT + ' DI SCONTO'
                          : 'ISCRIVITI ALLA NEWSLETTER';
      case 'pt': return A ? 'JUNTE-SE À NOSSA NEWSLETTER PARA OBTER ' + DISCOUNT + ' DE DESCONTO'
                          : 'JUNTE-SE À NOSSA NEWSLETTER';
      default:   return A ? 'JOIN OUR NEWSLETTER TO GET ' + DISCOUNT + ' OFF'
                          : 'JOIN OUR NEWSLETTER';
    }
  }

  function findNewsletterParagraphs() {
    var out = [];
    document.querySelectorAll('announcement-bar '+NEWSLETTER_HREF_SELECTOR).forEach(function(a){
      var p = a.querySelector('.metafield-rich_text_field > p');
      if (p && out.indexOf(p)===-1) out.push(p);
      else {
        var pf = a.querySelector('p');
        if (pf && out.indexOf(pf)===-1) out.push(pf);
      }
    });
    return out;
  }

  function apply(reason){
    var variant = resolveVariant();
    if (!variant) { log('Sin variante en storage/cookie → no se aplica (',reason,')'); return false; }

    var lang = getLang();
    var txt  = copyFor(lang, variant);
    var nodes = findNewsletterParagraphs();
    if (!nodes.length) { warn('No se encontraron nodos newsletter. Motivo:', reason); return false; }

    var changes = 0;
    nodes.forEach(function(p, i){
      var current = (p.textContent || '').trim();
      if (current !== txt) {
        p.textContent = txt;
        changes++;
        if (DEBUG) p.style.outline = '1px dashed #7b5cff';
        log('Render ['+i+'] ('+reason+')', {before: current, after: txt});
      }
    });

    if (changes && !activated) {
      activated = true;
      startObserver();
    }
    return changes > 0;
  }

  var debounce = null;
  function schedule(reason){ clearTimeout(debounce); debounce = setTimeout(function(){ apply(reason); }, 80); }

  function startObserver(){
    try {
      var root = document.querySelector('announcement-bar') || document.documentElement;
      observer = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          var m = muts[i];
          if (m.type==='childList' && (m.addedNodes.length || m.removedNodes.length)) { schedule('mutation-child'); return; }
          if (m.type==='attributes' && (m.attributeName==='class' || m.attributeName==='style')) { schedule('mutation-attr'); return; }
        }
      });
      observer.observe(root, { subtree:true, childList:true, attributes:true, attributeFilter:['class','style'] });
      log('Observer activado (post-apply)');
    } catch(e){ warn('Observer no disponible:', e); }
  }

  function boot(){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ apply('DOMContentLoaded'); });
    } else {
      apply('immediate');
    }
    window.addEventListener('load', function(){ apply('load'); });

    window.addEventListener('storage', function(e){
      if (e.key === 'zc_newsletterpopup_ws_ab_variant') apply('storage');
    });
  }
  window.AnnounceAB_apply = function(){ return apply('manual'); };

  boot();
})();


const ZC_AB = {
  testName: 'banner_v1',
  delayMs: 16500,
  cooldownDays: 7,
  variantTTLdays: 7, 
  keys: {
    variantCookie: 'zc_newsletterpopup_ws_ab_variant',
    variantLS: 'zc_newsletterpopup_ws_ab_variant',
    cooldownCookie: 'zc_newsletterpopup_ws_ab_cooldown',
    popupShownSession: 'zc_newsletterpopup_ws_ab_shown_session',
    variantSession: 'zc_newsletterpopup_ws_ab_variant_session',
    sessionId: 'zc_newsletterpopup_ws_session_id'
  },
  klaviyo: {
    A: 'YAs8du',
    B: 'TjGY2q'
  }
};

function setCookie(name, value, days){
  try{
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = `${name}=${encodeURIComponent(value)};path=/;SameSite=Lax;expires=${d.toUTCString()}`;
    return true;
  }catch(e){ return false; }
}
function getCookie(name){
  try{
    const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : null;
  }catch(e){ return null; }
}
function uuidv4(){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random()*16|0, v = c==='x'?r:(r&0x3|0x8); 
    return v.toString(16);
  });
}
function lsSetTTL(key, value, ttlDays){
  try{
    const exp = Date.now() + ttlDays*24*60*60*1000;
    localStorage.setItem(key, JSON.stringify({ v: value, exp }));
    return true;
  }catch(e){ return false; }
}
function lsGetTTL(key){
  try{
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || typeof obj !== 'object') return null;
    if (typeof obj.exp === 'number' && Date.now() > obj.exp){
      localStorage.removeItem(key);
      return null;
    }
    return obj.v;
  }catch(e){ return null; }
}
function lsSet(key, value){ try{ localStorage.setItem(key, value); return true; }catch(e){ return false; } }
function lsGet(key){ try{ return localStorage.getItem(key); }catch(e){ return null; } }

function fnv1a32(str){
  let h = 2166136261 >>> 0;
  for (let i=0;i<str.length;i++){
    h ^= str.charCodeAt(i);
    h = (h + ((h<<1)+(h<<4)+(h<<7)+(h<<8)+(h<<24))) >>> 0;
  }
  return h >>> 0;
}
function bucket(id){ return fnv1a32(id) % 100; }
function dlPush(obj) {
  if (!obj || typeof obj !== 'object') return;

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(obj);
  }

  if (window.gtag && obj.event) {
    const { event, ...params } = obj;
    gtag('event', event, params);
  }
}

function readPersistedVariant(){
  const vc = getCookie(ZC_AB.keys.variantCookie);
  if (vc === 'A' || vc === 'B') return vc;
  const vl = lsGetTTL(ZC_AB.keys.variantLS);
  if (vl === 'A' || vl === 'B') return vl;
  return null;
}

function determineTransientVariant(){
  return 'B'; //forzado a NOOFF
  const qp = new URLSearchParams(location.search);
  const forced = qp.get('zc_variant');
  if (forced && /^(A|B)$/i.test(forced)) return forced.toUpperCase();

  const persisted = readPersistedVariant();
  if (persisted) return persisted;

  const cid = (typeof window.SHOPIFY_CUSTOMER_ID !== 'undefined' && window.SHOPIFY_CUSTOMER_ID) ? String(window.SHOPIFY_CUSTOMER_ID) : null;
  if (cid) return bucket(cid) < 50 ? 'B' : 'A';

  try{
    let v = sessionStorage.getItem(ZC_AB.keys.variantSession);
    if (v === 'A' || v === 'B') return v;

    let sid = sessionStorage.getItem(ZC_AB.keys.sessionId);
    if (!sid){
      sid = uuidv4();
      sessionStorage.setItem(ZC_AB.keys.sessionId, sid);
    }
    v = bucket(sid) < 50 ? 'B' : 'A';
    sessionStorage.setItem(ZC_AB.keys.variantSession, v);
    return v;
  }catch(e){
    return Math.random() < 0.5 ? 'B' : 'A';
  }
}

function persistVariantFirm(variant){
  setCookie(ZC_AB.keys.variantCookie, variant, ZC_AB.variantTTLdays);
  lsSetTTL(ZC_AB.keys.variantLS, variant, ZC_AB.variantTTLdays);
  AnnounceAB_apply()
}

// =================== RUNTIME ===================
(function(){
  try{
    if (getCookie(ZC_AB.keys.cooldownCookie) === '1') return;

    let variant = determineTransientVariant();
    
    window.ZC_AB_STATE = { test: ZC_AB.testName, variant };

    dlPush({ event: 'zc_ab_assignment', zc_ab_test: ZC_AB.testName, zc_variation: variant });
    //SA('zc_ab_assignment', { src:'ab_test', extra: { zc_ab_test: ZC_AB.testName, zc_variation: variant } });

    try {
      if (sessionStorage.getItem(ZC_AB.keys.popupShownSession) === '1') return;
    } catch(e){}

    setTimeout(() => {
      if (getCookie(ZC_AB.keys.cooldownCookie) === '1') return;
      triggerVariantPopup(variant);
      persistVariantFirm(variant);

      dlPush({ event: 'zc_ab_popup_shown', zc_ab_test: ZC_AB.testName, zc_variation: variant });
      //SA('zc_ab_popup_shown', { src:'ab_test', extra: { zc_ab_test: ZC_AB.testName, zc_variation: variant } });

      try{ sessionStorage.setItem(ZC_AB.keys.popupShownSession, '1'); }catch(e){}
      setCookie(ZC_AB.keys.cooldownCookie, '1', ZC_AB.cooldownDays);

    }, ZC_AB.delayMs);

  }catch(err){
    console.error('ZC A/B popup error:', err);
  }
})();




// =================== DYNAMIC FS TRESHOLD ===================

;(function(){
  var DEBUG = false;
  var FS_SELECTOR = 'a[href*="#fs"]';
  var activated = false;
  var observer = null;
  var debounce = null;
  
  function log(){ if (DEBUG) console.log.apply(console, ['%c[FS-L10N]', 'color:#0aa;font-weight:bold;', ...arguments]); }
  function warn(){ if (DEBUG) console.warn.apply(console, ['[FS-L10N][WARN]', ...arguments]); }
  function schedule(reason){ clearTimeout(debounce); debounce = setTimeout(function(){ apply(reason); }, 80); }

  function getLang(){
    var l = (document.documentElement.getAttribute('lang') || (window.Shopify&&Shopify.locale) || navigator.language || 'en')+'';
    return l.toLowerCase().split('-')[0];
  }

  function formatCents(cents){
    var fmt =
      (window.theme && (theme.moneyWithCurrencyFormat || theme.moneyFormat)) ||
      (window.Shopify && Shopify.money_format) ||
      "${{amount}}";
    var intCents = Math.round(cents||0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(intCents, fmt);
    }
    var value = (intCents/100).toFixed(2);
    var re = /\{\{\s*amount(?:_with_(?:comma|space|apostrophe)_separator|_no_decimals(?:_with_(?:comma|space)_separator)?)?\s*\}\}/g;
    return fmt.replace(re, value);
  }

  async function getFSContext(){
    const rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    const thrBaseCents = window.ZC_FREE_SHIPPING?.baseThresholdCents ?? null;
    const country = window.ZC_FREE_SHIPPING?.country;
    const NO_CONVERT = (country === 'US' || country === 'GB');

    if (typeof thrBaseCents !== 'number') {
      const thrPres = window.ZC_FREE_SHIPPING?.thresholdActiveCents ?? null;
      return {
        leftBaseCents: null,
        thresholdBaseCents: null,
        leftPresentmentCents: null,
        thresholdPresentmentCents: thrPres,
        leftFormatted: '',
        thresholdFormatted: thrPres != null ? formatCents(thrPres) : '',
        haveLeft: false,
        leftCents: null,
        thresholdCents: null
      };
    }

    const subtotalPresCents = Math.max(0, Number(window.cart?.subtotal || 0));

    //const safeRate = rate || 1;
    const safeRate = NO_CONVERT ? 1 : (rate || 1);
    const subtotalBaseCents = Math.round(subtotalPresCents / safeRate);
    const leftBaseCents = Math.max(0, thrBaseCents - subtotalBaseCents);

    const thrPresCents = (window.ZC_FREE_SHIPPING?.thresholdActiveCents != null)
      ? window.ZC_FREE_SHIPPING.thresholdActiveCents
      : Math.round(thrBaseCents * safeRate);

    const leftPresCents = Math.round(leftBaseCents * safeRate);

    return {
      leftBaseCents,
      thresholdBaseCents: thrBaseCents,

      leftPresentmentCents: leftPresCents,
      thresholdPresentmentCents: thrPresCents,
      leftFormatted: formatCents(leftPresCents),
      thresholdFormatted: formatCents(thrPresCents),

      haveLeft: true,

      leftCents: leftBaseCents,
      thresholdCents: thrBaseCents
    };
  }


  function copyFor(lang, ctx){
    var left = ctx.leftFormatted;
    var thr  = ctx.thresholdFormatted;

    switch (lang) {
      case 'es':
        if (ctx.leftCents <= 0) return '¡ENVÍO GRATUITO DESBLOQUEADO!';
        if (ctx.leftCents === ctx.thresholdCents ) return `¡ENVÍO GRATUITO A PARTIR DE ${thr}!`;
        return ctx.haveLeft
          ? `¡SOLO TE FALTAN ${left} PARA EL ENVÍO GRATUITO!`
          : (thr ? `¡ENVÍO GRATUITO A PARTIR DE ${thr}!` : `¡ENVÍO GRATUITO!`);

      case 'en':
        if (ctx.leftCents <= 0) return 'FREE SHIPPING UNLOCKED!';
        if (ctx.leftCents === ctx.thresholdCents ) return `FREE SHIPPING FROM ${thr}!`;
        return ctx.haveLeft
          ? `ONLY ${left} AWAY FROM FREE SHIPPING!`
          : (thr ? `FREE SHIPPING FROM ${thr}!` : `FREE SHIPPING!`);

      case 'fr':
        if (ctx.leftCents <= 0) return 'LIVRAISON GRATUITE DÉBLOQUÉE !';
        if (ctx.leftCents === ctx.thresholdCents ) return `LIVRAISON GRATUITE DÈS ${thr} !`;
        return ctx.haveLeft
          ? `PLUS QUE ${left} POUR LA LIVRAISON GRATUITE !`
          : (thr ? `LIVRAISON GRATUITE DÈS ${thr} !` : `LIVRAISON GRATUITE !`);

      case 'de':
        if (ctx.leftCents <= 0) return 'GRATISVERSAND FREIGESCHALTET!';
        if (ctx.leftCents === ctx.thresholdCents ) return `GRATISVERSAND AB ${thr}!`;
        return ctx.haveLeft
          ? `NUR NOCH ${left} BIS ZUM GRATISVERSAND!`
          : (thr ? `GRATISVERSAND AB ${thr}!` : `GRATISVERSAND!`);

      case 'it':
        if (ctx.leftCents <= 0) return 'SPEDIZIONE GRATUITA SBLOCCATA!';
        if (ctx.leftCents === ctx.thresholdCents ) return `SPEDIZIONE GRATUITA DA ${thr}!`;
        return ctx.haveLeft
          ? `TI MANCANO SOLO ${left} ALLA SPEDIZIONE GRATUITA!`
          : (thr ? `SPEDIZIONE GRATUITA DA ${thr}!` : `SPEDIZIONE GRATUITA!`);

      case 'pt':
        if (ctx.leftCents <= 0) return 'FRETE GRÁTIS DESBLOQUEADO!';
        if (ctx.leftCents === ctx.thresholdCents ) return `FRETE GRÁTIS A PARTIR DE ${thr}!`;
        return ctx.haveLeft
          ? `FALTAM APENAS ${left} PARA FRETE GRÁTIS!`
          : (thr ? `FRETE GRÁTIS A PARTIR DE ${thr}!` : `FRETE GRÁTIS!`);

      default:
        if (ctx.leftCents <= 0) return 'FREE SHIPPING UNLOCKED!';
        if (ctx.leftCents === ctx.thresholdCents ) return `FREE SHIPPING FROM ${thr}!`;
        return ctx.haveLeft
          ? `ONLY ${left} AWAY FROM FREE SHIPPING!`
          : (thr ? `FREE SHIPPING FROM ${thr}!` : `FREE SHIPPING!`);
    }

  }


  function updateLeftToSpendDOM(ctx){
    const isUnlocked = (ctx.leftBaseCents != null && ctx.leftBaseCents <= 1);

    const amountCents =
      (ctx.leftPresentmentCents != null)
        ? (isUnlocked ? 0 : ctx.leftPresentmentCents)
        : (ctx.thresholdPresentmentCents != null ? ctx.thresholdPresentmentCents : 0);

    const formatted = formatCents(amountCents);

    //document.querySelectorAll('[data-left-to-spend-2]').forEach(el => {
    //  el.textContent = formatted;
    //});

  }


  function findTargets(){
    var out = [];
    document.querySelectorAll(FS_SELECTOR).forEach(function(a){
      out.push(a);
    });
    log('findTargets ', { out });
    return out;
  }

  async function apply(reason){
    var lang = getLang();
    var ctx  = await getFSContext();

    updateLeftToSpendDOM(ctx);

    var targets = findTargets();
    if (!targets.length) { warn('Sin targets FS. Motivo:', reason); return false; }

    var txt = copyFor(lang, ctx);
    var changes = 0;
    targets.forEach(function(a, i){
      var current = (a.textContent || '').trim();
      if (current !== txt) {
        a.textContent = txt;
        changes++;
        if (DEBUG) a.style.outline = '1px dashed #0aa';
        log('Render ['+i+'] ('+reason+')', { before: current, after: txt });
      }
    });

    if (changes && !activated) {
      activated = true;
      startObserver();
    }
    return changes > 0;
  }

  function startObserver(){
    try {
      var root = document.documentElement;
      observer = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          var m = muts[i];
          if (m.type==='childList' && (m.addedNodes.length || m.removedNodes.length)) { schedule('mutation-child'); return; }
          if (m.type==='attributes' && (m.attributeName==='class' || m.attributeName==='style')) { schedule('mutation-attr'); return; }
        }
      });
      observer.observe(root, { subtree:true, childList:true, attributes:true, attributeFilter:['class','style'] });
      log('Observer activado');
    } catch(e){ warn('Observer no disponible:', e); }
  }

  // ——— Boot ———
  function boot(){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ apply('DOMContentLoaded'); });
    } else {
      apply('immediate');
    }
    window.addEventListener('load', function(){ apply('load'); });

    document.addEventListener('zc:free-shipping:update', function(){ apply('fs-update'); });
    document.addEventListener('zc:free-shipping:init', function(){ apply('fs-init'); });

    ['cart:updated','product:added','ajaxProduct:added','theme:cart:update']
      .forEach(function(evt){ document.addEventListener(evt, function(){ apply(evt); }); });

    window.addEventListener('storage', function(){ apply('storage'); });
  }

  window.FS_copy_apply = function(){ return apply('manual'); };

  boot();
})();


// =================== DYNAMIC TOTEBAG THRESHOLD (#ft) ===================

;(function(){
  var DEBUG = false;

  var FT_A_SELECTOR = 'a[href="#ft"], a[href*="#ft"]';
  var FT_P_SELECTOR = 'a[href="#ft"] .metafield-rich_text_field p, a[href*="#ft"] .metafield-rich_text_field p';

  var TOTEBAG_BASE_THRESHOLD_CENTS = 7500; // 75.00€

  var activated = false;
  var observer = null;
  var debounce = null;

  function log(){ if (DEBUG) console.log.apply(console, ['%c[FT-L10N]', 'color:#b06;font-weight:bold;', ...arguments]); }
  function warn(){ if (DEBUG) console.warn.apply(console, ['[FT-L10N][WARN]', ...arguments]); }
  function schedule(reason){ clearTimeout(debounce); debounce = setTimeout(function(){ apply(reason); }, 80); }

  function getLang(){
    var l = (document.documentElement.getAttribute('lang') || (window.Shopify&&Shopify.locale) || navigator.language || 'en')+'';
    return l.toLowerCase().split('-')[0];
  }

  function formatCents(cents){
    var fmt =
      (window.theme && (theme.moneyWithCurrencyFormat || theme.moneyFormat)) ||
      (window.Shopify && Shopify.money_format) ||
      "${{amount}}";
    var intCents = Math.round(cents||0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(intCents, fmt);
    }
    var value = (intCents/100).toFixed(2);
    var re = /\{\{\s*amount(?:_with_(?:comma|space|apostrophe)_separator|_no_decimals(?:_with_(?:comma|space)_separator)?)?\s*\}\}/g;
    return fmt.replace(re, value);
  }

  async function getToteContext(){
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    if (!isFinite(rate) || rate <= 0) rate = 1;

    var thrBaseCents = TOTEBAG_BASE_THRESHOLD_CENTS;
    var subtotalPresCents = Math.max(0, Number(window.cart?.subtotal || 0));
    var subtotalBaseCents = Math.round(subtotalPresCents / rate);
    var leftBaseCents = Math.max(0, thrBaseCents - subtotalBaseCents);

    var thrPresCents  = Math.round(thrBaseCents * rate);
    var leftPresCents = Math.round(leftBaseCents * rate);

    return {
      leftBaseCents,
      thresholdBaseCents: thrBaseCents,

      leftPresentmentCents: leftPresCents,
      thresholdPresentmentCents: thrPresCents,

      leftFormatted: formatCents(leftPresCents),
      thresholdFormatted: formatCents(thrPresCents),

      haveLeft: true,

      leftCents: leftBaseCents,
      thresholdCents: thrBaseCents
    };
  }

  function copyFor(lang, ctx){
    var left = ctx.leftFormatted;
    var thr  = ctx.thresholdFormatted;

    switch (lang) {
      case 'es':
        if (ctx.leftCents <= 0) return '¡TOTEBAG GRATIS DESBLOQUEADA!';
        if (ctx.leftCents === ctx.thresholdCents) return `¡TOTEBAG GRATIS A PARTIR DE ${thr}!`;
        return `¡SOLO TE FALTAN ${left} PARA LA TOTEBAG GRATIS!`;

      case 'en':
        if (ctx.leftCents <= 0) return 'FREE TOTEBAG UNLOCKED!';
        if (ctx.leftCents === ctx.thresholdCents) return `FREE TOTEBAG FROM ${thr}!`;
        return `ONLY ${left} AWAY FROM A FREE TOTEBAG!`;

      case 'fr':
        if (ctx.leftCents <= 0) return 'TOTEBAG OFFERTE DÉBLOQUÉE !';
        if (ctx.leftCents === ctx.thresholdCents) return `TOTEBAG OFFERTE DÈS ${thr} !`;
        return `PLUS QUE ${left} POUR LA TOTEBAG OFFERTE !`;

      case 'de':
        if (ctx.leftCents <= 0) return 'GRATIS TOTEBAG FREIGESCHALTET!';
        if (ctx.leftCents === ctx.thresholdCents) return `GRATIS TOTEBAG AB ${thr}!`;
        return `NUR NOCH ${left} BIS ZUR GRATIS TOTEBAG!`;

      case 'it':
        if (ctx.leftCents <= 0) return 'TOTEBAG GRATIS SBLOCCATA!';
        if (ctx.leftCents === ctx.thresholdCents) return `TOTEBAG GRATIS DA ${thr}!`;
        return `TI MANCANO SOLO ${left} PER LA TOTEBAG GRATIS!`;

      case 'pt':
        if (ctx.leftCents <= 0) return 'TOTEBAG GRÁTIS DESBLOQUEADA!';
        if (ctx.leftCents === ctx.thresholdCents) return `TOTEBAG GRÁTIS A PARTIR DE ${thr}!`;
        return `FALTAM APENAS ${left} PARA A TOTEBAG GRÁTIS!`;

      default:
        if (ctx.leftCents <= 0) return 'FREE TOTEBAG UNLOCKED!';
        if (ctx.leftCents === ctx.thresholdCents) return `FREE TOTEBAG FROM ${thr}!`;
        return `ONLY ${left} AWAY FROM A FREE TOTEBAG!`;
    }
  }

  function findTargets(){
    var out = [];

    document.querySelectorAll(FT_P_SELECTOR).forEach(function(p){
      out.push({ node: p, mode: 'p' });
    });

    if (!out.length) {
      document.querySelectorAll(FT_A_SELECTOR).forEach(function(a){
        out.push({ node: a, mode: 'a' });
      });
    }

    log('findTargets', out.map(function(t){ return { mode: t.mode, node: t.node }; }));
    return out;
  }

  async function apply(reason){
    var lang = getLang();
    var ctx  = await getToteContext();

    var targets = findTargets();
    if (!targets.length) { warn('Sin target #ft. Motivo:', reason); return false; }

    var txt = copyFor(lang, ctx);
    var changes = 0;

    targets.forEach(function(t, i){
      var el = t.node;
      var current = (el.textContent || '').trim();
      if (current !== txt) {
        el.textContent = txt;
        changes++;
        if (DEBUG) el.style.outline = '1px dashed #b06';
        log('Render ['+i+'] ('+reason+')', { before: current, after: txt, mode: t.mode });
      }
    });

    if (changes && !activated) {
      activated = true;
      startObserver();
    }
    return changes > 0;
  }

  function startObserver(){
    try {
      var root = document.documentElement;
      observer = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          var m = muts[i];
          if (m.type==='childList' && (m.addedNodes.length || m.removedNodes.length)) { schedule('mutation-child'); return; }
          if (m.type==='attributes' && (m.attributeName==='class' || m.attributeName==='style')) { schedule('mutation-attr'); return; }
        }
      });
      observer.observe(root, { subtree:true, childList:true, attributes:true, attributeFilter:['class','style'] });
      log('Observer activado');
    } catch(e){ warn('Observer no disponible:', e); }
  }

  // ——— Boot ———
  function boot(){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ apply('DOMContentLoaded'); });
    } else {
      apply('immediate');
    }
    window.addEventListener('load', function(){ apply('load'); });

    // tus eventos (si los tienes)
    document.addEventListener('zc:tote:update', function(){ apply('tote-update'); });
    document.addEventListener('zc:tote:init', function(){ apply('tote-init'); });

    ['cart:updated','product:added','ajaxProduct:added','theme:cart:update']
      .forEach(function(evt){ document.addEventListener(evt, function(){ apply(evt); }); });

    window.addEventListener('storage', function(){ apply('storage'); });
  }

  window.FT_copy_apply = function(){ return apply('manual'); };

  boot();
})();


/* ZC · Shop-the-Look (tracking + line property) — standalone JS
   - Auto-inits Swiper for each STL section
   - Tracks impressions, nav clicks, and Add-to-Cart
   - Adds Shopify line item property: properties[_shop_the_look]=true
   - Sends events to gtag() and to your endpoint via sendBeacon/fetch
*/

(function () {
  const DEBUG = false;
  function log(...args) {
    if (DEBUG) console.log('[STL]', ...args);
  }

  const ENDPOINT = "https://susmies.net/api/events/enqueue.php";
  // const SECTION_SELECTOR = '[id^="zc-stl"]';
  // const SWIPER_SELECTOR = '.zc-stl-pdp__slider .swiper';
  const SECTION_SELECTOR = '[id^="zc-stl"], .zc-look-modal';
  const SWIPER_SELECTOR  = '.zc-stl-pdp__slider .swiper, .zc-look-swiper';
  const PROP_NAME = '_shop_the_look';
  const SRC = 'shop_the_look';

  // ---------- utilities ----------
  function uuidv4() {
    try { if (crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function nowSec() { return Math.floor(Date.now() / 1000); }
  function currencyCode() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  }
  function postPlain(obj) {
    // const body = JSON.stringify(obj);
    // try {
    //   if (navigator.sendBeacon) {
    //     const ok = navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
    //     if (ok) return Promise.resolve();
    //   }
    // } catch (e) {}
    // return fetch(ENDPOINT, {
    //   method: "POST",
    //   body: new Blob([body], { type: "text/plain" }),
    //   keepalive: true,
    //   mode: "cors",
    //   credentials: "omit"
    // }).catch(() => {});
  }
  function enrichVariant(variantId) {
    return fetch(`/variants/${variantId}.js`, { credentials: "same-origin", cache: "no-store" })
      .then(r => r.ok ? r.json() : null)
      .catch(() => null);
  }
  function getVariantIdFromNode(root) {
    const idInput = root.querySelector('input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);
    // Fallbacks
    const withData = root.closest('[data-variant-id], [data-product-variant], [data-variant]');
    const dataVal = withData?.dataset.variantId || withData?.dataset.productVariant || withData?.dataset.variant;
    return dataVal ? String(dataVal) : null;
  }
  function addLineProperty(form) {
    if (!form) return;
    const exists = form.querySelector(`input[name="properties[${PROP_NAME}]"]`);
    if (!exists) {
      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = `properties[${PROP_NAME}]`;
      inp.value = 'true';
      form.appendChild(inp);
    }
  }
  function toItemsPayloadFromSlides(slides) {
    const items = [];
    slides.forEach(slide => {
      const vid = getVariantIdFromNode(slide);
      if (vid) items.push({ item_id: String(vid) });
    });
    return items;
  }

  // ---------- event senders ----------
  function sendGtag(event_name, params) {
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', event_name, params || {}); } catch (_) {}
    }
    if (DEBUG) console.log('[STL][GTAG]', event_name, params);
  }

  function sendAPI(event_name, payload = {}) {
    const base = {
      event_id: uuidv4(),
      event_name,
      src: SRC,
      ts: nowSec(),
      currency: currencyCode(),
      page: { url: location.href, referrer: document.referrer },
      consent: true
    };
    return postPlain(Object.assign(base, payload));
  }

  function pushATCVariant(variantId, sharedEventId) {
    const eid = sharedEventId || uuidv4();
    log('➡️ ATC base a API', variantId, 'eid=', eid);

    const base = {
      event_id: eid,
      event_name: 'stl_add_to_cart',
      src: SRC,
      ts: nowSec(),
      currency: currencyCode(),
      items: [{ item_id: String(variantId), quantity: 1, shop_the_look: true }],
      page: { url: location.href, referrer: document.referrer },
      consent: true
    };
    //postPlain(base);

    enrichVariant(variantId).then(v => {
      if (!v) { log('⚠️ enrichVariant null'); return; }

      let price = null;
      if (typeof v.price === 'number') price = v.price / 100;
      else if (typeof v.price === 'string') {
        const f = parseFloat(v.price.replace(',', '.'));
        if (isFinite(f)) price = f;
      }

      const enriched = {
        event_id: eid,
        event_name: 'stl_add_to_cart',
        src: SRC,
        ts: nowSec(),
        currency: currencyCode(),
        items: [{
          item_id: String(variantId),
          item_name: v.name || v.title || undefined,
          price: price != null ? price : undefined,
          quantity: 1,
          sku: v.sku || undefined,
          product_id: v.product_id || undefined,
          shop_the_look: true
        }],
        page: { url: location.href, referrer: document.referrer },
        consent: true
      };
      postPlain(enriched);
      log('📤 Evento enriquecido enviado (API):', enriched);

      const gtagItems = [{
        item_id: String(variantId),
        item_name: v.name || v.title || undefined,
        price: price != null ? price : undefined,
        value: price != null ? price : undefined,
        sku: v.sku || undefined,
        quantity: 1,
        item_variant: undefined,
      }];

      sendGtag('stl_add_to_cart', {
        items: gtagItems,
        item_id: String(variantId),
        item_name: v.name || v.title || undefined,
        price: price != null ? price : undefined,
        value: price != null ? price : undefined,
        sku: v.sku || undefined,
        quantity: 1,
        currency: currencyCode(),
        shop_the_look: true,
        zc_stage: 'enriched',
        zc_event_id: eid
      });
      
    }).catch(err => log('❌ enrichVariant error', err));
  }


  function ensureSwiper(section) {
    const el = section.querySelector(SWIPER_SELECTOR);
    if (!el) return null;
    if (el.__zcSwiper) return el.__zcSwiper;
    if (typeof Swiper === 'undefined') return null;

    const prevEl = section.querySelector('.swiper-button-prev');
    const nextEl = section.querySelector('.swiper-button-next');

    const slideTotal = el.querySelectorAll('.swiper-slide').length;

    const DESKTOP_PER_VIEW = 2.2;
    const MOBILE_PER_VIEW  = 2.2;

    const USE_LOOP = slideTotal >= Math.ceil(DESKTOP_PER_VIEW);

    const swiper = new Swiper(el, {
      speed: 450,
      spaceBetween: 0,
      slidesPerView: MOBILE_PER_VIEW,
      slidesPerGroup: 1,
      resistanceRatio: 0.6,
      centerInsufficientSlides: true,
      loop: USE_LOOP,
      rewind: !USE_LOOP,
      loopAdditionalSlides: USE_LOOP ? 3 : 0,
      loopPreventsSliding: false,
      watchOverflow: !USE_LOOP,
      normalizeSlideIndex: true,
      observeParents: true,
      observer: false,
      observeSlideChildren: true,
      a11y: true,
      preloadImages: false,
      lazy: {
        checkInView: true,
        loadPrevNext: true,
        loadPrevNextAmount: 2,
        loadOnTransitionStart: true
      },
      navigation: { prevEl, nextEl },
      breakpoints: {
        900: { slidesPerView: DESKTOP_PER_VIEW, slidesPerGroup: 1 }
      },

      on: {
        init() {
          trackStlViewForSwiper(this);
        },
        transitionStart() {
          section.classList.add('is-animating');
          if (prevEl) prevEl.disabled = true;
          if (nextEl) nextEl.disabled = true;
        },
        transitionEnd() {
          section.classList.remove('is-animating');
          if (prevEl) prevEl.disabled = false;
          if (nextEl) nextEl.disabled = false;
          trackStlViewForSwiper(this);
          trackStlImpressionsForSwiper(this);
        }
      }
    });

    el.__zcSwiper = swiper;

    if (prevEl && !prevEl.__zcBound) {
      prevEl.addEventListener('click', () => {
        if (section.classList.contains('is-animating')) return;
        sendGtag('stl_nav', { direction: 'prev' });
        sendAPI('stl_nav',  { nav: { direction: 'prev' } });
      });
      prevEl.__zcBound = true;
    }

    if (nextEl && !nextEl.__zcBound) {
      nextEl.addEventListener('click', () => {
        if (section.classList.contains('is-animating')) return;
        sendGtag('stl_nav', { direction: 'next' });
        sendAPI('stl_nav',  { nav: { direction: 'next' } });
      });
      nextEl.__zcBound = true;
    }

    if (!swiper.initialized && typeof swiper.init === 'function') {
      swiper.init();
    }

    return swiper;
  }


  function visibleSlides(swiper) {
    const list = swiper?.visibleSlides || [];
    if (list.length) return Array.from(list);

    const slides = Array.from(swiper.el.querySelectorAll('.swiper-slide'));
    const start  = swiper.activeIndex || 0;
    const perView = Math.ceil(
      typeof swiper.params.slidesPerView === 'number' ? swiper.params.slidesPerView : 2
    );
    const end = Math.min(start + perView, slides.length);
    return slides.slice(start, end);
  }

  async function fireImpressions(section, swiper) {
    const slides = visibleSlides(swiper);
    if (!slides.length) return;

    const itemsBase = toItemsPayloadFromSlides(slides);
    if (!itemsBase.length) return;

    const ids = itemsBase.map(i => i.item_id).sort();
    const key = ids.join(',');

    if (swiper) {
      if (swiper.__zcLastImpressionKey === key) {
        return; 
      }
      swiper.__zcLastImpressionKey = key;
    }

    const ts = Math.floor(Date.now() / 1000);
    const eid = (crypto.randomUUID && crypto.randomUUID()) || String(ts + Math.random());
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

    const basePayload = {
      event_id: eid,
      event_name: 'stl_impression',
      src: 'shop_the_look',
      ts,
      currency,
      items: itemsBase,
      page: { url: location.href, referrer: document.referrer },
      consent: true
    };

    const enrichedItems = await Promise.all(
      itemsBase.map(async item => {
        try {
          const res = await fetch(`/variants/${item.item_id}.js`, { credentials: 'same-origin' });
          if (!res.ok) return item;
          const v = await res.json();
          let price = null;
          if (typeof v.price === 'number') price = v.price / 100;
          else if (typeof v.price === 'string') {
            const f = parseFloat(v.price.replace(',', '.'));
            if (isFinite(f)) price = f;
          }
          return {
            item_id: String(v.id),
            item_name: v.name || v.title,
            price: price != null ? price : undefined,
            sku: v.sku || undefined,
            product_id: v.product_id || undefined,
            shop_the_look: true
          };
        } catch {
          return item;
        }
      })
    );

    const enrichedPayload = {
      event_id: eid,
      event_name: 'stl_impression',
      src: 'shop_the_look',
      ts,
      currency,
      items: enrichedItems,
      page: { url: location.href, referrer: document.referrer },
      consent: true
    };

    sendGtag('stl_impression', enrichedPayload);
    sendAPI('stl_impression', enrichedPayload);
  }


  function getStlSectionFromSwiper(swiper) {
    if (!swiper || !swiper.el) return document;
    return swiper.el.closest(SECTION_SELECTOR) || document;
  }

  function trackStlViewForSwiper(swiper) {
    const section = getStlSectionFromSwiper(swiper);
    if (!section) return;

    if (section.__zcStlViewSent) return;
    section.__zcStlViewSent = true;

    // VIEW
    sendGtag('stl_view', {
      shop_the_look: true,
      zc_context: section.classList.contains('zc-look-modal') ? 'modal' : 'pdp'
    });

    sendAPI('stl_view', {});

    fireImpressions(section, swiper);
  }

  function trackStlImpressionsForSwiper(swiper) {
    const section = getStlSectionFromSwiper(swiper);
    if (!section) return;

    fireImpressions(section, swiper);
  }

  window.ZC_STL_TRACK = {
    view:        trackStlViewForSwiper,
    impressions: trackStlImpressionsForSwiper
  };



  // ---------- ATC interception (scoped to STL sections) ----------
  function handleATCClick(e) {
    const btn = e.target.closest('button, [type="submit"], .product-form__submit');
    if (!btn) return;
    const section = btn.closest(SECTION_SELECTOR);
    if (!section) return;

    const form = btn.closest('form');
    if (!form) return;

    addLineProperty(form);

    const variantId = getVariantIdFromNode(form) || getVariantIdFromNode(section);
    if (variantId) {
      const eid = uuidv4();
      pushATCVariant(variantId, eid);
    } else {
      sendGtag('stl_add_to_cart', { shop_the_look: true });
      sendAPI('stl_add_to_cart', { items: [], note: 'no_variant_found' });
    }
  }

  // ---------- boot ----------
  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(section => {
      ensureSwiper(section);
    });

    document.addEventListener('click', handleATCClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
document.addEventListener('DOMContentLoaded', function () {

  (function () {
    const isTouchDevice =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    if (!isTouchDevice) {
      return;
    }

    const TAP_MAX_DISTANCE = 10;
    const TAP_MAX_DURATION = 500;

    document.querySelectorAll('.product-item__image a, .product-link').forEach((link) => {
      let startX = 0;
      let startY = 0;
      let startTime = 0;

      // Guardamos dónde empezó el toque
      link.addEventListener('touchstart', function (ev) {
        const t = ev.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        startTime = Date.now();
      }, { passive: true });

      link.addEventListener('touchend', function (ev) {
        if (!startTime) return;

        const t = ev.changedTouches[0];
        const dx = Math.abs(t.clientX - startX);
        const dy = Math.abs(t.clientY - startY);
        const dt = Date.now() - startTime;

        const isTap = dx < TAP_MAX_DISTANCE && dy < TAP_MAX_DISTANCE && dt < TAP_MAX_DURATION;

        if (isTap) {
          if (ev.cancelable) ev.preventDefault();
          ev.stopPropagation();
          window.location.href = link.href;
        }

        // limpiamos
        startTime = 0;
      }, { passive: false, capture: true });
    });

  })();
});